import { MASONRY } from 'common/constants';
import { useMasonryDeeplinkInterceptor } from 'hooks/use-masonry-deeplink-interceptor/use-masonry-deeplink-interceptor.hook';

/**
 * While mounted, intercepts the Masonry `deeplink` action so "Try again" runs
 * `onRetry` instead of navigating.
 *
 * Retry is a deeplink rather than a Masonry `reload` because what needs re-running
 * is bootstrap (`resolve_plan_selection`), which is app code around Masonry.
 */
export const usePlanSwitcherRetry = (onRetry: () => void) => {
  useMasonryDeeplinkInterceptor(MASONRY.DEEPLINK_PLAN_SWITCHER_RETRY, onRetry);
};
